var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(-6.776 -6.776)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13888",
    "data-name": "Path 13888",
    d: "M8.6,7.09A1.069,1.069,0,1,0,7.089,8.6l6.175,6.175L7.089,20.951A1.069,1.069,0,1,0,8.6,22.463l6.175-6.174,6.175,6.175a1.069,1.069,0,1,0,1.512-1.512l-6.175-6.175L22.462,8.6A1.069,1.069,0,1,0,20.95,7.09l-6.175,6.175L8.6,7.089Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.4447afe6e5d236925fcd2f334956b3ab.svg";
export { ForwardRef as ReactComponent };